/** @format */

import { CategorySEOData } from './category-seo-url-token.interface';
import { CategoryChildVO } from './category-child-vo.interface';

export interface PersonalizedCategorySEOData extends Omit<CategorySEOData, 'childVOs'> {
  childVOs?: (CategoryChildVO | PersonalizedSubcategory)[];
}

// https://github.com/dsg-tech/pz-web-features/blob/master/src/services/PersonalizationService/handlers/Drawers/types.ts
export interface PersonalizedSubcategory {
  // Required fields
  em: string;
  name?: string;
  seoUrl: string;
  url?: string;
  pageType: string;

  // Optional fields
  action?: 'add' | 'update' | 'remove';
  position?: number;
  id?: string;
  note?: string;
  targetImage?: string;
  expanded?: boolean;
  fullImage?: string;
  panelOpenState?: boolean;
  childVOs?: PersonalizedSubcategory[];
  subcategories?: PersonalizedSubcategory[];
}

export interface CategorizedOperations {
  removeIds: Set<string>;
  updateMap: Map<string, PersonalizedSubcategory>;
  addMap: Map<string, PersonalizedSubcategory>;
}
